export default "/react/logoAutorules-e0570bd3.png";